<p>Anabiz支払い</p>
<button id="ssn-test-ana-biz" class="testButton" (click)="anaBizTest1()">Anabiz画面へ</button>
<button id="organizationSelectRequiredBiz" class="testButton" (click)="organizationSelectRequired()">
  bizコンテキスト初期化
</button>
<button id="anabizPaymentPrevScreenSet" class="testButton" (click)="initPrevScreenStore()">
  前画面情報ストア初期化
</button>
<asw-select label="契約形態" [formControl]="selectContractType" (change$)="contractTypeChange()">
  <option value="01">P契約</option>
  <option value="02">BPS契約</option>
  <option value="03">板カード契約</option>
</asw-select>
<asw-checkbox label="発券要求機能使用するか" (change$)="issueFlagUpdate($event)"></asw-checkbox>
